export default "__VITE_ASSET__BzpiNYKj__"